/**
 * @file  index.tsx
 * @description  application entry point to render the app main component and associated routes
 *
 * @author ogarcia (ozkary)
 */
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { render } from 'react-dom';
import './content/index.scss';
import './content/styles.scss';
import './nonce.ts';
import App from './App';
import * as serviceWorker from './serviceWorkerRegistration';
import { reportWebVitals, sendToAnalytics } from './reportWebVitals';
import accessibility from './accessibility';

// renders the main app. routing is handle by the routing component inside app
render(
  <React.StrictMode>
    <BrowserRouter>
    <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(sendToAnalytics);

// bootstrap the accessibility widget to the document body
// add a accessibility site key to the env file for each deployment
accessibility();
